<template>
  <div class="teamDetails">
    <div class="topTitle">
      <span style="cursor: pointer;" @click="goback1">返回</span> /
      {{ teamMessage.title }}
    </div>

    <el-row :gutter="10" style="padding-left:10px;padding-right:10px;">
      <el-col :span="16">
        <div style="background:white;padding:10px 20px 20px 20px;border-radius: 5px;">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="概况" name="second">
              <div>
                <div style="font-weight:bold;margin-top:20px;font-size:16px;">
                  团队数据
                </div>

                <el-card style="margin-top: 20px;" shadow="never">
                  <div>
                    <ul class="clearfix dataTop">
                      <li class="fl" @click="changeTch" style="cursor: pointer;">
                        <div class="clearfix">
                          <div class="fl dataPic">
                            <img src="https://wugecdn.steam.fun/resources/static/oj/people.png" width="100%" />
                          </div>
                          <div class="fl dataTxt">
                            <div>助教教师</div>
                            <div style="margin-top: 5px; font-weight: bold;">
                              <span style="color:#409EFF;" v-if="
                                  teamInfo.assistant_user_num == undefined ||
                                    teamInfo.assistant_user_num == null
                                ">--</span>
                              <span v-else style="color:#409EFF;">{{
                                teamInfo.assistant_user_num
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </li>

                      <li class="fl">
                        <div class="clearfix">
                          <div class="fl dataPic">
                            <img src="https://wugecdn.steam.fun/resources/static/oj/people.png" width="100%" />
                          </div>
                          <div class="fl dataTxt">
                            <div>团队成员</div>
                            <div style="margin-top: 5px; font-weight: bold;">
                              <span v-if="totalTeamStuNum === null">--</span>
                              <span v-else>{{ totalTeamStuNum }}</span>
                            </div>
                          </div>
                        </div>
                      </li>

                      <li class="fl">
                        <div class="clearfix">
                          <div class="fl dataPic">
                            <img src="https://wugecdn.steam.fun/resources/static/oj/tidan.png" width="100%" />
                          </div>
                          <div class="fl dataTxt">
                            <div>题单数</div>
                            <div style="margin-top: 5px; font-weight: bold;">
                              <span v-if="totalTeamProblemListNum === null">--</span>
                              <span v-else>{{ totalTeamProblemListNum }}</span>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="fl">
                        <div class="clearfix">
                          <div class="fl dataPic">
                            <img src="https://wugecdn.steam.fun/resources/static/oj/timu.png" width="100%" />
                          </div>
                          <div class="fl dataTxt">
                            <div>题目数</div>
                            <div style="margin-top: 5px; font-weight: bold;">
                              <span v-if="totalTeamProblemNum === null">--</span>
                              <span v-else>{{ totalTeamProblemNum }}</span>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </el-card>

                <div style="margin-top: 38px;">
                  <div class="clearfix">
                    <div class="fl" style="font-weight: bold;font-size:16px;">
                      提交统计
                    </div>
                    <div class="fr">
                      <!-- :picker-options="pickerOptions" -->
                      <el-date-picker @change="chengTime" style="width:250px;" size="mini" format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="formTime.outWarehouseTimeLine1" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" placement="bottom-start">
                      </el-date-picker>
                    </div>
                    <div class="fr">
                      <el-form @submit.native.prevent ref="form" :inline="true" :model="formstu" label-width="" size="mini">
                        <el-form-item label="学员姓名">
                          <el-select @change="changeStu" multiple collapse-tags v-model="formstu.stuIdArr" filterable placeholder="请选择" clearable>
                            <el-option v-for="item in optionsStu" :key="item.student_user_id" :label="item.realname" :value="item.student_user_id">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-form>
                    </div>
                  </div>
                  <div style="width: 100%; height: calc(100vh - 470px);">
                    <el-empty v-if="dataListTotal.length === 0" description="暂无数据"></el-empty>
                    <div v-if="dataListTotal.length != 0" style="width: 100%; height: 100%;" id="myChart1"></div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="团队题单" name="third">
              <div>
                <el-button type="text" icon="el-icon-plus" style="font-weight:bold;" @click="addProblemList">添加题单</el-button>
                <el-button type="text" icon="el-icon-delete" @click="dels2" style="font-weight:bold;">批量移除</el-button>

                <div style="float:right;line-height:20px;cursor: pointer;" @click="changeSoltNum">
                  <svg t="1681976002001" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2605" width="20" height="20">
                    <path d="M358.265 273.813l-111.561 94.165c-19.508 16.466-48.67 14-65.136-5.508-16.466-19.507-14-48.67 5.508-65.135l187.597-158.346c30.052-25.365 76.036-4.003 76.036 35.322v682.667c0 25.528-20.694 46.222-46.222 46.222-25.528 0-46.222-20.694-46.222-46.222V273.813z m410.837 389.409c19.507-16.466 48.67-14 65.135 5.508 16.466 19.507 14 48.67-5.507 65.135L641.132 892.211c-30.05 25.365-76.036 4.003-76.036-35.322V174.222c0-25.528 20.695-46.222 46.223-46.222 25.527 0 46.222 20.694 46.222 46.222v583.165l111.56-94.165z" fill="#797979" p-id="2606"></path>
                  </svg>
                  <span style="line-height:20px;float:right;">设置排序</span>
                </div>

                <el-table ref="singleTable" highlight-current-row @row-click="rowChange" :data="tableData1" height="58vh" style="width: 100%;margin-top:10px" :header-cell-style="{ color: '#333', background: 'white' }" @selection-change="handleSelectionChange5">
                  <el-table-column type="selection" width="55">
                  </el-table-column>

                  <el-table-column prop="title" label="题单名称" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                      <span class="tableTxtHover" @click.stop="
                          goProblem(
                            scope.row.problemListInfo,
                            scope.$index,
                            scope.row
                          )
                        ">{{ scope.row.problemListInfo.title }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column prop="problem_num" label="题数" width="50" align="center">
                    <template slot-scope="scope">
                      <span>{{ scope.row.problemListInfo.problem_num }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="" label="题单类型" width="80px">
                    <template slot-scope="scope">
                      <span v-if="
                          scope.row.problemListInfo.oj_problem_list_type_id ===
                            null
                        ">--</span>
                      <span v-else>
                        <span>{{
                          scope.row.problemListInfo.totalInfo.title
                        }}</span>
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column prop="problem_num" label="完成情况" width="80" align="center">
                    <!-- userNum -->
                    <template slot-scope="scope">
                      {{ scope.row.userNum }} / {{ stuNum }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="created_time" label="添加时间" width="170px" align="center">
                  </el-table-column>

                  <el-table-column prop="" label="操作" align="center" width="100" fixed="right">
                    <template slot-scope="scope">
                      <el-button type="text" @click="
                          goProblem(
                            scope.row.problemListInfo,
                            scope.$index,
                            scope.row
                          )
                        ">查看</el-button>
                      <el-button type="text" @click="del2(scope.row.problemListInfo)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div style="margin: 20px; text-align: right">
                  <el-pagination @current-change="handleCurrent1" :current-page="page_no1" :page-size="page_size1" layout="total, prev, pager, next, jumper" :total="total1">
                  </el-pagination>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="团队成员" name="fourth">
              <div>
                <div class="clearfix">
                  <div class="fl">
                    <el-button type="text" icon="el-icon-plus" style="font-weight:bold;" @click="addstu">添加学生</el-button>
                    <el-button type="text" icon="el-icon-delete" style="font-weight:bold;" @click="dels1">批量移除</el-button>
                  </div>
                  <div class="fr">
                    <el-button type="text" style="font-weight:bold;" @click="limits">题解权限</el-button>
                  </div>
                </div>

                <el-table ref="singleTable1" highlight-current-row @row-click="rowstuList" :data="tableData2" height="calc(100vh - 355px)" style="width: 100%;margin-top:10px" :header-cell-style="{ color: '#333', background: 'white' }" @selection-change="handleSelectionChange3">
                  <el-table-column type="selection" width="55">
                  </el-table-column>
                  <el-table-column type="index" label="序号" width="55">
                  </el-table-column>

                  <el-table-column width="60" label="头像" align="center">
                    <template slot-scope="scope">
                      <el-image style="width: 30px; height: 30px" :src="scope.row.headImgUrl" fit="cover"></el-image>
                    </template>
                  </el-table-column>

                  <el-table-column prop="realname" label="姓名">
                  </el-table-column>

                  <el-table-column align="left" prop="sex" label="性别" width="50"></el-table-column>

                  <el-table-column prop="name" label="平台账号" width="120"></el-table-column>

                  <el-table-column prop="normal_state" label="AC数">
                    <template slot-scope="scope">
                      <span v-if="scope.row.submissionInfo != null">
                        {{ scope.row.submissionInfo.pass_count }}
                      </span>
                      <span v-else>--</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="normal_state" label="提交数">
                    <template slot-scope="scope">
                      <span v-if="scope.row.submissionInfo != null">
                        {{ scope.row.submissionInfo.submit_count }}
                      </span>
                      <span v-else>--</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="" label="题解" width="100">
                    <template slot-scope="scope">
                      <div @click.stop>
                        <el-switch @change="changeSwitch(scope.row)" v-model="scope.row.oj_analysis_auth" active-color="#13ce66" inactive-color="grey">
                        </el-switch>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="" label="操作" width="100">
                    <template slot-scope="scope">
                      <el-button type="text" @click="del1(scope.row)">移除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div style="margin: 20px; text-align: right">
                  <el-pagination @current-change="handleCurrent2" :current-page="page_no2" :page-size="page_size2" layout="total, prev, pager, next, jumper" :total="total2">
                  </el-pagination>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-col>
      <el-col v-if="activeName === 'second'" :span="8">
        <div class="right_top" style="background:white;border-radius:5px;max-height: 96px;">
          <div class="clearfix">
            <div style="font-weight:bold;">
              <svg t="1658393812149" @click="addTema" style="float:right;cursor:pointer;" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8974" width="18" height="18">
                <path d="M857.4 722.7c-4 84-73.5 151.2-158.3 151.2H324.8c-84.8 0-154.3-67.1-158.3-151.2h-0.2V299.3h0.2c4-84.1 73.5-151.3 158.3-151.3H640l-68.3 57.7H324.8C269.3 205.9 224 251.3 224 307v408c0 55.7 45.3 101.1 100.8 101.1H699.1c55.6 0 100.8-45.4 100.8-101.1V429.5l57.6-56.8v350h-0.1zM658.4 469l-41.8 44.1c-13.9 14.2-48.9 49.7-60 61.5-11.1 11.8-20.4 21.5-27.6 29.2-7.3 7.6-11.7 12-13 13.1-3.5 3.2-7.5 6.7-12 10.3-4.5 3.6-9.2 6.5-14.1 8.7-4.9 2.6-12 5.6-21.4 9.3-9.4 3.6-19.2 7.1-29.5 10.6s-20 6.4-29.2 9c-9.2 2.5-16.1 4.2-20.6 4.9-9.4 1.1-15.6-0.4-18.8-4.4-3.1-4-4-10.8-2.6-20.1 0.7-5.1 2.4-12.5 5-22.1 2.6-9.6 5.4-19.6 8.3-30 3-10.3 5.8-19.9 8.6-28.6 2.8-8.7 5-14.7 6.8-18 2.1-5 4.4-9.7 7.1-13.9 2.6-4.2 6.3-8.8 11.2-13.9 2.1-2.2 7-7.4 14.6-15.5 7.6-8.2 39.7-40.8 51.2-52.8l38.1-39.8 42.3-44.1 108-112.8 98.4 99.8-109 115.5z m176.5-186c-5.2 5.4-9.8 10.2-14 14.2-4.1 4.1-7.7 7.7-10.7 10.8-3.5 3.6-6.7 6.8-9.7 9.5l-97.9-99.8c5.2-5 11.4-11 18.5-18s13.1-12.5 17.9-16.6c6.1-5 12.4-8.5 18.9-10.5 6-1.9 11.8-2.8 17.6-2.7h1.6c3.2 0.1 6.3 0.4 9.4 1h-0.3 0.3c13.2 2.5 27 9.6 38.7 20.9 6.5 6.3 11.8 13.4 15.6 20.6 5.7 10.7 8.4 21.9 7.8 32.1 0 1.2 0.1 2.5 0.1 3.8 0 5.9-1.1 11.8-3.3 17.7-2.2 5.9-5.7 11.6-10.5 17z m0 0" p-id="8975" fill="#515151"></path>
              </svg>
              <svg style="float:left;margin-right:10px;" t="1658450998090" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11846" width="18" height="18">
                <path d="M232.0384 648.06912l2.08896 0.8192 197.38624 63.16032 61.56288 213.1968a72.74496 72.74496 0 0 1-10.48576 62.01344 68.11648 68.11648 0 0 1-23.79776 20.76672c-9.4208 4.9152-19.74272 7.45472-30.26944 7.45472-26.2144 0-51.65056-8.76544-72.66304-25.02656a126.68928 126.68928 0 0 1-43.90912-65.20832l-79.872-277.17632z m649.216-574.6688c12.00128 0 23.51104 4.95616 31.98976 13.80352 8.47872 8.8064 13.27104 20.80768 13.27104 33.30048v706.56c0 12.4928-4.79232 24.45312-13.27104 33.30048a44.40064 44.40064 0 0 1-31.98976 13.80352c-12.04224 0-23.552-4.95616-32.03072-13.80352a48.128 48.128 0 0 1-13.27104-33.30048V120.50432c0-12.4928 4.79232-24.49408 13.27104-33.30048 8.47872-8.84736 19.98848-13.80352 32.03072-13.80352z m-90.5216 94.208v612.352l-588.5952-188.416v-235.52l588.5952-188.416zM156.8768 356.02432v235.52H111.616c-12.00128 0-23.51104-4.95616-31.98976-13.80352a48.08704 48.08704 0 0 1-13.27104-33.30048v-141.312c0-12.4928 4.75136-24.49408 13.27104-33.30048 8.47872-8.84736 19.98848-13.80352 31.98976-13.80352H156.8768z" fill="#2E78DD" p-id="11847"></path>
              </svg>
              <span style="float:left;line-height:18px;margin-right:10px;font-size:16px;">
                团队公告
              </span>
            </div>
          </div>
          <div style="margin-top:20px;">
            <span class="clearfix">
              <span class="fl" style="width: calc(100% - 67px);text-overflow: -o-ellipsis-lastline;overflow: hidden;	text-overflow: ellipsis;	display: -webkit-box;-webkit-line-clamp: 1;line-clamp: 1;-webkit-box-orient: vertical;	">
                <span v-if="noticTxt == ''">暂无公告</span>
                <span v-html="noticTxt"></span>
              </span>
              <span v-if="noticTxt != ''" class="fr" style="line-height: 18px;font-size: 14px;cursor: pointer;" @click="moreTxt">更多...</span>
            </span>
          </div>
        </div>
        <div>
          <div class="right_top" style="background:white; margin-top: 10px;border-radius:5px 5px 0px 0px;">
            <div class="clearfix" style="padding: 0 20px;margin-top: 30px;margin-left: 10%;">
              <div class="fl" style="width: 33%;height: 63px; margin-right: -5%;position: relative;bottom: -22px;">
                <img src="https://wlmvp-cos.weiling.cn/worktable-h5/icon/top2_bg.png" style="width: 100%;height: 100%; " />
                <div v-if="userde != undefined" style="position: absolute; top: 50%; left: 50%;  transform: translate(-50%, -50%);">
                  <div style="font-weight:bold;">{{ userde.name }}</div>
                  <div style="text-align: center;">{{ userde.pass_count }}</div>
                </div>
                <div v-if="userde != undefined" style="position: absolute;top:-35px;left: 50%;margin-left: -20px;">
                  <div class="dierBox2">
                    <img :src="userde.headImgUrl" style="width: 100%;" />
                  </div>
                  <div style="position: absolute;top: -8px;right: -5px;">
                    <img src="../../../assets/image/top2.png" style="width: 20px;" />
                  </div>
                </div>
              </div>
              <div class="fl" style="width: 33%; height: 85px; position: relative ;z-index: 999;">
                <img src="https://wlmvp-cos.weiling.cn/worktable-h5/icon/top1_bg.png" style="width: 100%; height: 100%;" />
                <div v-if="userdy != undefined" style="position: absolute; top: 50%; left: 50%;  transform: translate(-50%, -50%);">
                  <div style="font-weight:bold;">{{ userdy.name }}</div>
                  <div style="text-align: center;">{{ userdy.pass_count }}</div>
                </div>
                <div v-if="userdy != undefined" style="position: absolute;top:-30px;left: 50%;margin-left: -20px;">
                  <div class="dierBox1">
                    <img :src="userdy.headImgUrl" style="width: 100%;" />
                  </div>
                  <div style="position: absolute;top: -8px;right: -5px;">
                    <img src="../../../assets/image/top1.png" style="width: 20px;" />
                  </div>
                </div>
              </div>
              <div class="fl" style="width: 33%;height: 40px; margin-left: -5%;position: relative;bottom:-45px">
                <img src="https://wlmvp-cos.weiling.cn/worktable-h5/icon/top3_bg.png" style="width: 100%; height: 100%;" />
                <div v-if="userds != undefined" style="position: absolute; top: 50%; left: 50%;  transform: translate(-50%, -50%);font-size: 10px;">
                  <div style="font-weight:bold;">{{ userds.name }}</div>
                  <div style="text-align: center;">{{ userds.pass_count }}</div>
                </div>
                <div v-if="userds != undefined" style="position: absolute;top:-38px;left: 50%;margin-left: -20px;">
                  <div class="dierBox3">
                    <img :src="userds.headImgUrl" style="width: 100%;" />
                  </div>
                  <div style="position: absolute;top: -8px;right: -5px;">
                    <img src="../../../assets/image/top3.png" style="width: 20px;" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tableContent" style="width: 100%;border-radius:5px; background: #fff; overflow-y: auto;">
          <el-table v-el-table-infinite-scroll="loadTable" :data="tableDataSoltUser" :header-cell-style="{ background: '#f3f7fb', color: '#333' }" style="width: 100%" height="calc(100vh - 415px)">
            <el-table-column prop="date" label="排名" align="center">
              <template slot-scope="scope">{{ scope.$index + 1 }}</template>
            </el-table-column>
            <el-table-column prop="" label="头像">
              <template slot-scope="scope">
                <div style="width: 30px; height: 30px; overflow: hidden; border-radius: 50%;">
                  <img :src="scope.row.headImgUrl" style="width: 100%;" />
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="姓名"> </el-table-column>
            <el-table-column prop="pass_count" label="AC数"> </el-table-column>
            <el-table-column prop="submit_count" label="提交量">
            </el-table-column>
          </el-table>

          <!-- <el-alert v-if="isMore" title="没有更多啦！" type="warning" center show-icon>
          </el-alert> -->
        </div>
      </el-col>
      <el-col v-if="activeName === 'third'" :span="8">
        <div style="padding: 20px;background:white;border-bottom:1px solid #fdfdfd;border-radius:5px 5px 0 0">
          <span style="font-weight:bold;font-size:16px; font-weight: bold;">题单完成情况:</span>
          <span style="margin-left:10px;font-size:16px;">
            {{ tidanTitle }}</span>
        </div>
        <div class="tableContent" style="width: 100%;height: calc(100vh - 214px); border-radius:0px 0px 5px 5px;background: #fff; overflow-y: auto;">
          <el-empty v-if="userTdList.length == 0" description="暂无完成的学员"></el-empty>

          <ul v-else style="height: 100%;" class="tableContent">
            <li v-for="(item, index) in userTdList" :key="index" style="padding: 10px; border-bottom: 1px solid #F5F5F5;">
              <div class="clearfix">
                <div class="fl" style="line-height: 35px;margin-right: 15px;font-weight: bold; width: 50px;text-align: center;">
                  {{ index + 1 }}
                </div>
                <div class="fl" style="width: 35px;height: 35px;border: 1px solid #ccc;border-radius:50%;overflow: hidden;">
                  <img :src="item.headImgUrl" style="width: 100%;" />
                </div>
                <div class="fl" style="margin-left: 20px; line-height: 35px;">
                  {{ item.name }}
                </div>

                <div class="fr" style="width: 115px;margin-top: 10px;">
                  <el-progress :text-inside="true" :stroke-width="16" :percentage="setItemProgress(item)" :format="setItemText(item)"></el-progress>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </el-col>
      <el-col v-if="activeName === 'fourth'" :span="8" style="border-radius:5px;">
        <div v-if="isShowProblem">
          <div style="padding:20px;background: #fff;border-radius:5px;" class="clearfix">
            <el-page-header @back="closeProblem" :content="problemListInfoList.ttile">
            </el-page-header>
          </div>
          <div style="width: 100%;height: calc(100vh - 215px);background: #fff;" v-el-table-infinite-scroll="loadTableMessageTable" class="tableContent1">
            <el-table @row-click="showSubmit" v-el-table-infinite-scroll="loadTableMessageTable" :data="problemListRelationList" :header-cell-style="{ background: '#f7f7f7', color: '#333' }" style="width: 100%;" height="100%">
              <el-table-column prop="date" label="序号" width="55" align="center">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>

              <el-table-column label="编号" prop="code" width="80">
                <template slot-scope="scope">
                  <span>{{ scope.row.problemInfo.code }}</span>
                </template>
              </el-table-column>

              <el-table-column prop="" label="题目">
                <template slot-scope="scope">
                  <span>{{ scope.row.problemInfo.title }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="name" label="姓名">
              </el-table-column> -->
              <el-table-column label="状态" width="80" align="center">
                <template slot-scope="scope">
                  <span v-for="(item, index) in scope.row.submissionInfo" :key="index">
                    <svg t="1658296902087" v-if="item.pass_count === 1" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13040" width="15" height="15">
                      <path d="M0 0h1024v1024H0V0z" fill="#202425" opacity=".01" p-id="13041"></path>
                      <path d="M955.733333 512c0 245.077333-198.656 443.733333-443.733333 443.733333S68.266667 757.077333 68.266667 512 266.922667 68.266667 512 68.266667s443.733333 198.656 443.733333 443.733333z" fill="#11AA66" p-id="13042"></path>
                      <path d="M512 102.4C285.7984 102.4 102.4 285.7984 102.4 512s183.3984 409.6 409.6 409.6 409.6-183.3984 409.6-409.6S738.2016 102.4 512 102.4zM34.133333 512C34.133333 248.081067 248.081067 34.133333 512 34.133333s477.866667 213.947733 477.866667 477.866667-213.947733 477.866667-477.866667 477.866667S34.133333 775.918933 34.133333 512z" fill="#11AA66" p-id="13043"></path>
                      <path d="M787.114667 339.285333a51.2 51.2 0 0 1 0 72.362667l-307.2 307.2a51.2 51.2 0 0 1-72.362667 0l-170.666667-170.666667a51.2 51.2 0 0 1 72.362667-72.362666L443.733333 610.235733l271.018667-271.018666a51.2 51.2 0 0 1 72.362667 0z" fill="#FFFFFF" p-id="13044"></path>
                    </svg>
                    <svg t="1658296992015" v-if="item.pass_count === 0" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13965" width="15" height="15">
                      <path d="M827.392 195.584q65.536 65.536 97.792 147.456t32.256 167.936-32.256 167.936-97.792 147.456-147.456 98.304-167.936 32.768-168.448-32.768-147.968-98.304-98.304-147.456-32.768-167.936 32.768-167.936 98.304-147.456 147.968-97.792 168.448-32.256 167.936 32.256 147.456 97.792zM720.896 715.776q21.504-21.504 18.944-49.152t-24.064-49.152l-107.52-107.52 107.52-107.52q21.504-21.504 24.064-49.152t-18.944-49.152-51.712-21.504-51.712 21.504l-107.52 106.496-104.448-104.448q-21.504-20.48-49.152-23.04t-49.152 17.92q-21.504 21.504-21.504 52.224t21.504 52.224l104.448 104.448-104.448 104.448q-21.504 21.504-21.504 51.712t21.504 51.712 49.152 18.944 49.152-24.064l104.448-104.448 107.52 107.52q21.504 21.504 51.712 21.504t51.712-21.504z" p-id="13966" fill="#d81e06"></path>
                    </svg>
                  </span>
                  <span v-if="scope.row.submissionInfo.length === 0">—</span>
                </template>
              </el-table-column>
              <el-table-column prop="submit_count" label="提交量" align="center">
                <template slot-scope="scope">
                  <span v-for="(item, index) in scope.row.submissionInfo" :key="index">
                    <el-link :underline="false" type="primary">{{
                      item.submit_count
                    }}</el-link>
                  </span>
                  <!-- this.$store.state.user.identity -->
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <div style="padding:20px;background: #fff;border-radius:5px;">
            <span style="font-size:16px;font-weight:bold;">题单通过情况</span>
          </div>
          <div v-el-table-infinite-scroll="loadTableMessage" class="tableContent" style="width: 100%;height: calc(100vh - 212px);background: #fff;">
            <el-table :data="stuListUser" :header-cell-style="{ background: 'white' }" style="width: 100%;" height="100%">
              <el-table-column prop="date" label="序号" align="center" width="70">
                <template slot-scope="scope">{{ scope.$index + 1 }}</template>
              </el-table-column>
              <el-table-column prop="" label="题单名称" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.problemListInfo.title }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="完成度" width="100">
                <template slot-scope="scope">
                  <div v-if="
                      scope.row.submissionInfo &&
                        scope.row.submissionInfo.join('') !== ''
                    ">
                    <div v-for="(item, index) in scope.row.submissionInfo" :key="index">
                      <el-progress :text-inside="true" :stroke-width="16" :percentage="setItemProgress1(item)" :format="setItemText1(item)"></el-progress>
                    </div>
                  </div>
                  <div v-else class="el-icon-minus"></div>
                </template>
              </el-table-column>

              <el-table-column prop="" label="操作" width="50">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="goProblemList(scope.row)">查看</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!-- <el-alert v-if="isMore1" title="没有更多啦！" type="warning" center show-icon>
          </el-alert> -->
        </div>
      </el-col>
    </el-row>

    <el-drawer custom-class="demo-drawer" title="团队公告" z-index="1000" :visible.sync="dialogVisible" size="40%">
      <!-- <Tinymce v-model="teamMessage.notic"></Tinymce> -->

      <el-form ref="teamMessage" :model="teamMessage" :rules="rules">
        <el-form-item label="">
          <Tinymce v-model="noticTxt"></Tinymce>
        </el-form-item>
      </el-form>
      <div class="demo-drawer__footer clearfix">
        <div class="fr" style="margin-right: 20px;">
          <el-button @click="close">取 消</el-button>
          <el-button type="primary" @click="submit('teamMessage')">确 定</el-button>
        </div>
      </div>
    </el-drawer>
    <el-dialog title="添加题目" :visible.sync="dialogVisible1" width="80%" top="5vh">
      <el-form :inline="true" size="mini">
        <el-form-item label="">
          <el-input v-model="title_code" @keydown.13.native="search" @keydown.229.native="() => {}" placeholder="请输入题号、标题" style="width:200px;" clearable></el-input>
        </el-form-item>

        <el-form-item label="按知识点筛选">
          <el-cascader @change="changeKonw" style="width: 230px;" v-model="form.Know" :props="Konwprops" :options="KnowledgeList" collapse-tags clearable></el-cascader>
        </el-form-item>
        <el-form-item label="按难度筛选">
          <el-select style="width: 230px;" multiple collapse-tags v-model="form.conditions" placeholder="请选择" clearable>
            <el-option v-for="item in conditionList" :key="item.id" :label="item.title" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="按来源筛选">
          <el-select style="width: 230px;" multiple collapse-tags v-model="form.source" placeholder="请选择" clearable>
            <el-option v-for="item in sourceList" :key="item.id" :label="item.title" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="tableData4" height="55vh" size="mini" stripe style="width: 100%;" :header-cell-style="{ background: '#f5f7fa' }" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="code" label="题号"> </el-table-column>
        <el-table-column prop="title" label="标题"> </el-table-column>
        <el-table-column label="标签">
          <template slot-scope="scope">
            <span v-for="item in scope.row.problemTagArr" :key="item.id">
              {{ item.tagInfo.title }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="submit1">确 定</el-button>
      </span>
      <div style="margin: 20px; text-align: right">
        <el-pagination @current-change="handleCurrent4" :current-page="page_no4" :page-size="page_size4" layout="total, prev, pager, next, jumper" :total="total4">
        </el-pagination>
      </div>
    </el-dialog>

    <el-dialog title="添加学生" :visible.sync="dialogVisible2" width="80%" top="5vh">
      <el-form ref="form" label-width="70px" :inline="true" size="mini">
        <el-form-item label="学员姓名">
          <el-input v-model="formStu.realname" clearable placeholder="请输入学员姓名"></el-input>
        </el-form-item>

        <el-form-item label="学员账号">
          <el-input v-model="formStu.username" clearable placeholder="请输入学员账号"></el-input>
        </el-form-item>

        <el-form-item label="班级名称">
          <el-input v-model="formStu.className" clearable placeholder="请输入班级名称"></el-input>
        </el-form-item>

        <el-button type="primary" icon="el-icon-search" @click="search2" size="mini">查询</el-button>
      </el-form>

      <el-table height="55vh" :data="tableData5" size="mini" stripe style="width: 100%;" :header-cell-style="{ background: '#f5f7fa' }" @selection-change="handleSelectionChange2">
        <el-table-column type="selection" width="55"> </el-table-column>

        <el-table-column align="center" width="50" label="序号" fixed="left">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 + (page_no6 - 1) * page_size6 }}</span>
          </template>
        </el-table-column>

        <el-table-column label="学员姓名" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.realName }}</span>
          </template>
        </el-table-column>

        <el-table-column width="100" align="center" prop="sex" label="性别"></el-table-column>

        <el-table-column prop="name" label="平台账号" width="150"></el-table-column>

        <el-table-column label="有效期" width="100">
          <template slot-scope="scope">
            <span>
              <span v-if="scope.row.enddate">
                {{ scope.row.enddate.slice(0, 10) }}
              </span>
              <span style="color: #e6a23c" v-else>请设置有效期</span>
            </span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="所在班级" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.class_str }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="schoolName" label="校区"> </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="submit2">确 定</el-button>
      </span>
      <div style="margin: 20px; text-align: right">
        <el-pagination @current-change="handleCurrent5" :current-page="page_no5" :page-size="page_size5" layout="total, prev, pager, next, jumper" :total="total5">
        </el-pagination>
      </div>
    </el-dialog>

    <el-dialog title="添加题单" :visible.sync="dialogVisible3" width="60%" top="5vh">
      <el-form ref="formTitle" :inline="true" size="mini">
        <el-form-item label="题单名称">
          <el-input v-model="formTitle.title_code" @keydown.13.native="search1" @keydown.229.native="() => {}" clearable placeholder="请输入题单名称"></el-input>
        </el-form-item>
        <el-form-item label="题单类型">
          <el-select v-model="formTitle.oj_problem_list_type_id" filterable placeholder="请选择" clearable>
            <el-option v-for="item in ojProblemListTypeList1" :key="item.id" :label="item.title" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-button type="primary" icon="el-icon-search" @click="search1" size="mini">查询
        </el-button>
      </el-form>
      <el-table :data="tableData6" height="55vh" size="mini" stripe style="width: 100%;" :header-cell-style="{ color: '#909399', background: '#f5f7fa' }" @selection-change="handleSelectionChange4">
        <el-table-column type="selection" width="55"> </el-table-column>

        <el-table-column align="center" width="50" label="序号" fixed="left">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 + (page_no6 - 1) * page_size6 }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="title" label="题单名称"> </el-table-column>

        <el-table-column prop="problem_num" label="题目数量"> </el-table-column>
        <el-table-column prop="" label="题单类型">
          <template slot-scope="scope">
            <span v-if="scope.row.oj_problem_list_type_id === null">--</span>
            <span v-else>
              <span>{{ scope.row.totalInfo.title }}</span>
            </span>
          </template>
        </el-table-column>

        <el-table-column label="创建人">
          <template slot-scope="scope">
            <span v-if="!scope.row.user_id">官方题单</span>
            <span v-else>{{ scope.row.realname }}</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="submit3">确 定</el-button>
      </span>
      <div style="margin: 20px; text-align: right">
        <el-pagination @current-change="handleCurrent6" :current-page="page_no6" :page-size="page_size6" layout="total, prev, pager, next, jumper" :total="total6">
        </el-pagination>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="isShowSoltNum" width="60%" top="10vh">
      <div class="TableSolt">
        <el-table height="50vh" row-key="id" :data="tableDataSolt" tooltip-effect="dark" size="mini" style="width: 100%;" :header-cell-style="{ color: '#909399', background: '#f5f7fa' }">
          <el-table-column type="index" align="center" label="序号">
          </el-table-column>
          <el-table-column prop="title" label="题目名称">
            <template slot-scope="scope">
              <span>
                <span>{{ scope.row.problemListInfo.title }}</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="题目数量">
            <template slot-scope="scope">
              <span>
                <span>{{ scope.row.problemListInfo.problem_num }}</span>
              </span>
            </template>
          </el-table-column>

          <el-table-column prop="" label="操作" width="100" align="center">
            <template slot-scope="">
              <i class="el-icon-rank" style="cursor: pointer;"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowSoltNum = false">取 消</el-button>
        <el-button type="primary" @click="submitSoltNum">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="团队公告" :visible.sync="moretxt" width="40%">
      <div style="max-height:50vh;overflow-y:scroll">
        <span v-html="noticTxt"></span>
      </div>
    </el-dialog>

    <el-drawer :visible.sync="drawerjl" :with-header="false" size="86%">
      <div class="clearfix">
        <div class="fl" style="width:calc(50% - 10px)">
          <el-table @row-click="showisShowExample" ref="subMitList" :data="subMitRecord" highlight-current-row height="calc(100vh - 86px)" style="width: 100%;" :header-cell-style="{ background: 'white', color: '#333' }">
            <el-table-column prop="code" label="序号" align="center" width="100">
              <template slot-scope="scope">{{ scope.$index + 1 }}</template>
            </el-table-column>

            <el-table-column label="耗时">
              <template slot-scope="scope">
                <span v-if="scope.row.time_cost === null">0ms</span>
                <span v-else>{{ scope.row.time_cost }}ms</span>
              </template>
            </el-table-column>
            <el-table-column label="内存">
              <template slot-scope="scope">
                <span>{{ scope.row.memory_cost / 1024 }}kb</span>
              </template>
            </el-table-column>
            <el-table-column prop="created_time" label="提交时间" show-overflow-tooltip width="180">
            </el-table-column>
            <el-table-column label="状态" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.result === -1">程序输出不正确</span>
                <span v-if="scope.row.result === 0">程序输出正确</span>
                <span v-if="scope.row.result === 1">超时</span>
                <span v-if="scope.row.result === 2">超时</span>
                <span v-if="scope.row.result === 3">内存超限</span>
                <span v-if="scope.row.result === 4">程序运行错误</span>
                <span v-if="scope.row.result === 5">系统错误</span>
                <span v-if="scope.row.result === -2">编译失败</span>
                <span v-if="scope.row.result === 6">等待测评</span>
                <span v-if="scope.row.result === 7">测评中</span>
                <span v-if="scope.row.result === 8">部分输出正确</span>
              </template>
            </el-table-column>
            <el-table-column prop="score" label="得分">
              <template slot-scope="scope">
                <span @click="showisShowExample(scope.row)">{{
                  scope.row.score
                }}</span>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin: 20px; text-align: right">
            <el-pagination @current-change="handleCurrent2" :current-page="page_onSubmit" :page-size="page_sizeSubmit" layout="total, prev, pager, next, jumper" :total="totalSubmit">
            </el-pagination>
          </div>
        </div>
        <div class="fr" style="width:calc(50% - 12px);border-left: 2px solid #f2f6fc; min-height: 100vh; padding-left: 10px;padding-right: 10px;">
          <div style="margin-top: 12px; font-size: 16px;">
            <span style="font-weight: bold;">问题:</span>
            <span style="margin-left:10px;">{{ ojProblemInfo.code }}</span>
            <span style="margin-left: 10px;">{{ ojProblemInfo.title }}</span>
          </div>
          <div style="margin-top: 12px;overflow-y: auto;border-radius:5px;">
            <code-mirror v-model="code"></code-mirror>
          </div>
        </div>
      </div>
    </el-drawer>
    <el-dialog title="解析权限" :visible.sync="showlimits" width="250px">
      <div class="clearfix">
        <div class="fl">
          <el-button type="primary" @click="openlimits">开启解析</el-button>
        </div>
        <div class="fr">
          <el-button @click="closelimits">关闭解析</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="助教老师" :visible.sync="dialogVisible4" width="50%" top="7vh">
      <div style="overflow: hidden;">
        <div style="float:right">
          <span v-if="isShowTxt">
            <span class="el-icon-plus" style="cursor:pointer;" v-if="isShow" @click="addTch">添加助教老师</span>
            <div v-else>
              <el-form :inline="true" :model="formInline1" size="small">
                <el-form-item label="老师姓名" style="margin-bottom: 0px;">
                  <el-select v-model="formInline1.assistant_user_id_arr" style="width: 250px" clearable multiple collapse-tags>
                    <el-option :label="item.realName + ' ' + '(' + item.name + ')'" :value="item.id" v-for="(item, index) of teacherList1" :key="index"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item style="margin-bottom: 0px;">
                  <el-button type="text" @click="submitTch">确认</el-button>
                  <el-button type="text" @click="isShow = true">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
          </span>
        </div>
      </div>
      <el-table size="mini" :data="tchTable" height="50vh" style="width: 100%;margin-top: 15px;" :header-cell-style="{ color: '#909399', background: '#f5f7fa' }">
        <el-table-column prop="" label="头像">
          <template slot-scope="scope">
            <img :src="scope.row.userInfo.headImg" style="width: 25px;height: 25px; margin-top: 5px;" />
          </template>
        </el-table-column>
        <el-table-column prop="" label="助教老师">
          <template slot-scope="scope">
            {{ scope.row.userInfo.realname }}
          </template>
        </el-table-column>
        <el-table-column prop="" label="账号">
          <template slot-scope="scope">
            {{ scope.row.userInfo.name }}
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作">
          <template slot-scope="scope">
            <el-button :disabled="!isShowTxt" type="text" size="mini" @click="delTch(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import Tinymce from '@/components/Tinymce'
import Sortable from 'sortablejs'
import moment from 'moment'
import CodeMirror from '@/components/CodeMirror'

import {
  ojTchDeleteTeamAssistant,
  tchAddOrUpdateOjTeam,
  tchGetOjProblemListForTeamAddProblem,
  tchAddProblemForTeam,
  // tchGetProblemForTeam,
  tchDeleteProblemForTeam,
  tchGetStuListForAddTeamStu,
  tchAddTeamStu,
  tchGetTeamStuList,
  tchDeleteTeamStu,
  tchGetOjProblemlistForTeamAddProblemlist,
  tchAddProblemlistForTeam,
  tchGetProblemListForTeam,
  tchDeleteProblemListForTeam,
  getTeamOjSubmissionList,
  getOjProblemDifficultyList, //按难度筛选
  getOjProblemTagGroupList, //知识点
  getOjProblemSourceList, //来源
  tchGetTeamTotalData,
  tchGetTeamStuRank,
  tchGetProblemListForSearchStuSubmitIn,
  tchGetProblemListForTeamSort,
  tchUpdateProblemListSortOfTeam,
  tchGetTeamStuListNoPage,
  ojTchGetTeamSubmissiontTotal,
  ojTchGetStuProblemListAndSubmission,
  getOneUserOjSubmissionListForTeam,
  ojTchUpdateTeamAllStuOjAnalysisAuth,
  ojTchUpdateTeamSingleStuOjAnalysisAuth,
  ojTchGetOjProblemListTypeListWithOutP,
  updateOjTeamAssistant,
  ojTchGetTeamAssistant,
} from '@/api/educational.js'

import { api_tchSelectTchListByEdu } from '@/api/javaApi'
// import ListOfUestionsList from "../ListOfUestions/ListOfUestionsList.vue";
// import { nextTick } from "process";
// import { tchGetOjContestSignList } from "../../../api/educational";
export default {
  components: {
    Tinymce,
    CodeMirror,
  },

  data() {
    return {
      teamInfo: {},
      isShowTxt: true,
      teacherList1: [],
      formInline1: {
        assistant_user_id_arr: [],
      },
      isShow: true,
      tchTable: [],
      // pickerOptions: {
      //   disabledDate(time) {
      //     const yesterday = Date.now() - 86400000
      //     const thirtyDaysAgo = yesterday - 29 * 86400000
      //     return time.getTime() < thirtyDaysAgo || time.getTime() > yesterday
      //   },
      // },
      dialogVisible4: false,
      ojProblemListTypeList1: [],
      showlimits: false,
      ProblemLength: 0,
      code: '',
      ojProblemInfo: {},
      subMitRecord: [],
      page_onSubmit: 1,
      page_sizeSubmit: 10,
      totalSubmit: 1,
      drawerjl: false,
      problemListRelationList: [],
      problemListRelationList1: [],
      problemListInfoList: {
        team_problemlist_relation_id: '',
        stuId: '',
        page_no: 1,
        page_size: 10,
        total: 1,
      },
      teamProblemlistRelationId: '',

      isShowProblem: false,
      noticTxt: '',
      optionsStu: [],
      formstu: {
        stuIdArr: [],
      },
      moretxt: false,
      tableHeight: '', //表格高度
      userdy: {},
      userde: {},
      userds: {},
      stuListUserId: '',
      stuListUser: [], //学生
      stuListUser1: [], //学生

      page_noStu: 1,
      page_sizeStu: 20,
      totaStu: 0,
      isMore1: false,
      userTdList: [], //团队题单点击列表
      tidanTitle: '', //题单标题
      //
      totalTeamStuNum: null,
      totalTeamProblemNum: null,
      totalTeamProblemListNum: null,
      tableDataSoltUser: [],
      tableDataSoltUser1: [],
      page_noSolt: 1,
      page_sizeSolt: 20,
      totaSolt: 0,
      isMore: false,
      isflag: false,
      //统计时间
      formTime: {
        outWarehouseTimeLine1: [
          moment()
            .subtract(7, 'days')
            .format('YYYY-MM-DD'),
          moment()
            .subtract(1, 'days')
            .format('YYYY-MM-DD'),
        ],
      },
      soltIds: [],
      //题目排序
      tableDataSolt: [],
      //题单
      isShowSoltNum: false,
      isShowTable: true,
      //来源
      sourceList: [],
      //知识点
      KnowledgeList: [],
      Konwprops: {
        value: 'id',
        label: 'title',
        children: 'tagArrInfo',
        multiple: true,
      },
      //难度
      conditionList: [],
      //
      form: {
        conditions: [],
        Know: [],
        source: [],
        Know1: [],
      },
      dataListTotal: [],
      //题单
      formTitle: {
        isAccept: '3',
      },
      dialogVisible3: false,
      page_no6: 1,
      page_size6: 20,
      total6: 20,
      tableData6: [],
      multipleSelection4: [],
      multipleSelection5: [],

      //成员
      formStu: {},
      dialogVisible2: false,
      page_no5: 1,
      page_size5: 20,
      total5: 20,
      tableData5: [],
      multipleSelection2: [],
      multipleSelection3: [],

      //题目

      title_code: '',
      dialogVisible1: false,
      tableData4: [],
      page_no4: 1,
      page_size4: 20,
      total4: 20,
      dialogVisible: false,
      teamMessage: {},
      tableData3: [],
      page_no3: 1,
      page_size3: 20,
      total3: 20,
      formInline: {
        region: '',
      },
      page_no2: 1,
      page_size2: 10,
      total2: 1,
      tableData2: [],
      page_no1: 1,
      page_size1: 10,
      total1: 1,
      tableData1: [],
      stuNum: 0,
      content: '',
      activeName: 'second',
      page_no: 1,
      page_size: 20,
      total: 20,
      tableData: [],
      rules: {
        title: [
          {
            required: true,
            message: '请输入标签名称',
            trigger: 'change',
          },
          {
            required: true,
            message: '请输入标签名称',
            trigger: 'blur',
          },
        ],
        code: [
          {
            required: true,
            message: '请输入编号',
            trigger: 'change',
          },
          {
            required: true,
            message: '请输入编号',
            trigger: 'blur',
          },
        ],
      },
      multipleSelection: [],
      multipleSelection1: [],

      stu_name: '',
    }
  },

  created() {
    this.teamMessage = JSON.parse(this.$route.query.team)
    console.log(this.teamMessage, 12121212)
    if (this.$route.query.ProblemLength === undefined) {
      this.ProblemLength = 0
    } else {
      this.ProblemLength = this.$route.query.ProblemLength
    }
    if (this.$route.query.activeName === undefined) {
      console.log(121212, 121245)
    } else {
      this.activeName = this.$route.query.activeName
      if (this.$route.query.activeName === 'second') {
        this.page_no = this.$route.query.page_no
        this.page_size = this.$route.query.page_size
        // this.tchGetProblemForTeam()
      }
      console.log(this.$route.query.activeName, 12121545121)
      if (this.$route.query.activeName === 'third') {
        this.page_no1 = this.$route.query.page_no
        this.page_size1 = this.$route.query.page_size
        this.tchGetProblemListForTeam()
      }
    }
  },
  // activated() {
  //   this.teamMessage = JSON.parse(this.$route.query.team)
  //   this.activeName === 'second'

  // },

  mounted() {
    this.noticTxt = sessionStorage.getItem('notic')
    console.log(this.noticTxt, 12121)
    this.tchGetTeamStuListNoPage()
    console.log(this.$route.query.activeName, 121245)
    this.ojTchGetOjProblemListTypeListWithOutlist()

    this.getOjProblemDifficultyList() //按难度筛选
    this.getOjProblemTagGroupList() //知识点
    this.getOjProblemSourceList() //来源
    if (this.activeName === 'second') {
      // this.tchGetProblemForTeam()
      this.tchGetTeamTotalData()
      this.tchGetTeamStuRank()
      this.$nextTick(() => {
        this.ojTchGetTeamSubmissiontTotal()
        // this.getTableHeight()
      })
    }
    if (this.activeName === 'fourth') {
      this.tchGetTeamStuList()
    }
    if (this.activeName === 'third') {
      this.tchGetProblemListForTeam()
    }
    if (this.activeName === 'fifth') {
      this.getTeamOjSubmissionList()
    }
    // this.gerTime()
  },
  computed: {
    // tableStuLength() {
    //   return this.total2 + this.multipleSelection2.length;
    // },
  },
  watch: {
    // tableStuLength(val) {
    //   console.log(val, 45613213);
    // },
    // this.problemListRelationList1
    isShowProblem(val) {
      console.log(val, 452121)
      if (val === false) {
        this.problemListInfoList.page_no = 1
        this.problemListRelationList1 = []
        this.problemListRelationList = []
      }
    },
  },
  // beforeDestroy() {
  //   sessionStorage.setItem('notic', '')

  // },
  methods: {
    delTch(row) {
      console.log(row, 123456)
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          ojTchDeleteTeamAssistant({
            teamAssistantId: row.id,
          }).then(() => {
            this.ojTchGetTeamAssistant()
            this.tchGetTeamTotalData()
            this.$message({
              type: 'success',
              message: '删除成功!',
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    submitTch() {
      updateOjTeamAssistant({
        team_id: this.teamMessage.id,
        assistant_user_id_arr: JSON.stringify(
          this.formInline1.assistant_user_id_arr
        ),
      }).then((res) => {
        console.log(res, 12346)
        this.isShow = true
        this.formInline1.assistant_user_id_arr = []
        this.ojTchGetTeamAssistant()
        this.tchGetTeamTotalData()
      })
      console.log(this.formInline1.assistant_user_id_arr, 123456)
    },
    changeTch() {
      console.log(123456)
      if (this.$store.state.user.userInfo.id != this.teamMessage.user_id) {
        this.isShowTxt = false
      } else {
        this.isShowTxt = true
      }
      this.isShow = true
      this.ojTchGetTeamAssistant()
      this.dialogVisible4 = true
    },
    ojTchGetTeamAssistant() {
      ojTchGetTeamAssistant({
        team_id: this.teamMessage.id,
      }).then((res) => {
        console.log(res, 123456)
        this.tchTable = res.ojTeamAssisTantList
        this.formInline1.assistant_user_id_arr = []
        this.tchTable.map((item) => {
          this.formInline1.assistant_user_id_arr.push(item.user_id)
        })
      })
    },
    addTch() {
      this.tchSelectTchListByEdu()
      this.isShow = false
    },
    //获得教师列表
    tchSelectTchListByEdu() {
      api_tchSelectTchListByEdu().then((res) => {
        console.log(res, 12345678945)
        this.teacherList1 = res
      })
    },
    ojTchGetOjProblemListTypeListWithOutlist() {
      ojTchGetOjProblemListTypeListWithOutP({}).then((res) => {
        console.log(res)
        this.ojProblemListTypeList1 = res.ojProblemListTypeList
      })
    },
    changeSwitch(row) {
      console.log(row, 121212)
      ojTchUpdateTeamSingleStuOjAnalysisAuth({
        stuId: row.student_user_id,
        oj_analysis_auth: row.oj_analysis_auth === false ? '0' : '1',
      }).then(() => {
        this.$message.success('修改成功')
        this.page_noStu = 1
        this.stuListUser1 = []
        this.stuListUser = []
        this.tchGetTeamStuList()
        this.showlimits = false
      })
    },
    //批量开关权限
    limits() {
      this.showlimits = true
    },
    closelimits() {
      ojTchUpdateTeamAllStuOjAnalysisAuth({
        team_id: this.teamMessage.id,
        oj_analysis_auth: '0',
      }).then((res) => {
        console.log(res)
        this.$message.success('关闭题解成功')
        this.page_noStu = 1
        this.stuListUser1 = []
        this.stuListUser = []
        this.tchGetTeamStuList()
        this.showlimits = false
      })
    },
    openlimits() {
      ojTchUpdateTeamAllStuOjAnalysisAuth({
        team_id: this.teamMessage.id,
        oj_analysis_auth: '1',
      }).then((res) => {
        console.log(res)
        this.$message.success('开启题解成功')
        this.page_noStu = 1
        this.stuListUser1 = []
        this.stuListUser = []
        this.tchGetTeamStuList()
        this.showlimits = false
      })
    },
    closeProblem() {
      this.isShowProblem = false
    },

    //
    //查看提交代码
    showSubmit(row) {
      if (row.submissionInfo.length === 0) {
        this.$message.warning('暂无提交')
      } else {
        console.log(row, 1212124541)
        this.ojProblemInfo.code = row.problemInfo.code
        this.ojProblemInfo.title = row.problemInfo.title
        console.log(row, 12145)
        getOneUserOjSubmissionListForTeam({
          problem_id: row.oj_problem_id,
          code: row.submissionInfo[0].userCode,
          page_no: this.page_onSubmit,
          page_size: this.page_sizeSubmit,
          team_problemlist_relation_id: this.teamProblemlistRelationId,
        }).then((res) => {
          console.log(res, 45121)
          this.subMitRecord = res.submissionList
          this.$nextTick(() => {
            this.$refs.subMitList.setCurrentRow(this.subMitRecord[0])
          })
          this.code = this.subMitRecord[0].code
          this.totalSubmit = res.total
          this.drawerjl = true
        })
      }
    },
    showisShowExample(row) {
      this.code = row.code
    },
    //
    goProblemList(row) {
      this.problemListRelationList1 = []
      // this.problemListRelationList = []
      console.log(row, 12145)
      this.problemListInfoList.ttile = row.problemListInfo.title
      this.problemListInfoList.id = row.problemListInfo.id
      this.teamProblemlistRelationId = row.id
      ojTchGetStuProblemListAndSubmission({
        // problemlist_id: this.problemListInfoList.id,
        team_problemlist_relation_id: row.id,
        stuId: this.problemListInfoList.stuId,
        page_no: this.problemListInfoList.page_no,
        page_size: this.problemListInfoList.page_size,
      }).then((res) => {
        console.log(res, 456523)
        // problemListRelationList
        this.problemListRelationList1 = res.problemListRelationList
        this.problemListRelationList.push(...this.problemListRelationList1)
        this.isShowProblem = true
      })
    },
    loadTableMessageTable() {
      if (
        this.problemListRelationList1.length <
        this.problemListInfoList.page_size
      ) {
        console.log(111)
      } else {
        this.problemListRelationList1 = []

        this.problemListInfoList.page_no += 1
        ojTchGetStuProblemListAndSubmission({
          // problemlist_id: this.problemListInfoList.id, 注释等待错误
          team_problemlist_relation_id: this.teamProblemlistRelationId,
          stuId: this.problemListInfoList.stuId,
          page_no: this.problemListInfoList.page_no,
          page_size: this.problemListInfoList.page_size,
        }).then((res) => {
          console.log(res, 456523)
          this.problemListRelationList1 = res.problemListRelationList
          this.problemListRelationList.push(...this.problemListRelationList1)
          this.isShowProblem = true
        })
      }
    },
    //统计
    ojTchGetTeamSubmissiontTotal() {
      ojTchGetTeamSubmissiontTotal({
        team_id: this.teamMessage.id,
        start_date: this.formTime.outWarehouseTimeLine1[0],
        end_date: this.formTime.outWarehouseTimeLine1[1],
        stuIdArr: JSON.stringify(this.formStu.stuIdArr),
      }).then((res) => {
        console.log(res, 11212)
        this.dataListTotal = res.returnDate

        console.log(res.returnDate, 11212)

        let time = []
        let pass = []
        let submit = []
        res.returnDate.map((item) => {
          // time.push(item.count_date)
          // time.push(item.count_date.slice(0, item.count_date.length - 9))
          time.push(item.count_date.substring(0, 10))

          pass.push(item.pass_count)
          submit.push(item.submit_count)
        })
        console.log(time, 11212)
        console.log(pass, 11212)
        console.log(submit, 11212)
        this.$nextTick(() => {
          this.drawLine1(time, pass, submit)
        })
      })
    },
    chengTime() {
      this.ojTchGetTeamSubmissiontTotal()
    },
    changeStu(val) {
      console.log(val, 415121)
      this.tableDataSoltUser1 = []
      this.tableDataSoltUser = []
      this.formStu.stuIdArr = val
      this.page_noSolt = 1
      this.tchGetTeamStuRank()
      this.ojTchGetTeamSubmissiontTotal()
    },

    tchGetTeamStuListNoPage() {
      tchGetTeamStuListNoPage({
        team_id: this.teamMessage.id,
      }).then((res) => {
        console.log(res, 1321323)
        this.optionsStu = res.ojTeamStuRelatiohList
      })
    },
    moreTxt() {
      this.moretxt = true
    },

    //排名
    tchGetTeamStuRank() {
      // this.tableLoading = true;
      tchGetTeamStuRank({
        stuIdArr: JSON.stringify(this.formStu.stuIdArr),
        team_id: this.teamMessage.id,
        page_no: this.page_noSolt,
        page_size: this.page_sizeSolt,
      }).then((res) => {
        console.log(res, 5465323)
        this.tableDataSoltUser1 = []
        this.tableDataSoltUser1 = res.returnData
        this.tableDataSoltUser.push(...this.tableDataSoltUser1)
        this.userdy = this.tableDataSoltUser[0]
        this.userde = this.tableDataSoltUser[1]
        console.log(this.userde, 562323)
        this.userds = this.tableDataSoltUser[2]
        this.totaSolt = res.total
      })
    },
    loadTable() {
      if (this.tableDataSoltUser1.length < this.page_sizeSolt) {
        console.log(111)
      } else {
        this.page_noSolt += 1
        this.tchGetTeamStuRank()
        this.isMore = true
      }
    },
    // getTableHeight() {
    //   let tableH = 20; //距离页面下方的高度
    //   let tableHeightDetil = window.innerHeight - tableH;
    //   if (tableHeightDetil <= 300) {
    //     this.tableHeight = 300;
    //   } else {
    //     this.tableHeight = window.innerHeight - tableH;
    //   }
    // },

    //
    tchGetTeamTotalData() {
      tchGetTeamTotalData({
        team_id: this.teamMessage.id,
      }).then((res) => {
        console.log(res, 452321)
        this.teamInfo = res.teamInfo
        this.totalTeamStuNum = res.totalTeamStuNum
        this.totalTeamProblemNum = res.totalTeamProblemNum
        this.totalTeamProblemListNum = res.totalTeamProblemListNum
      })
    },
    //概况
    drawLine1(time, pass, submit) {
      // 基于准备好的dom，初始化echarts实例
      // let myChart1 = this.$echarts.init(document.getElementById("myChart1"));
      let b = document.getElementById('myChart1')
      b.removeAttribute('_echarts_instance_')
      let myChart1 = this.$echarts.init(b)
      // 绘制员工数
      myChart1.setOption({
        title: { text: '' },
        tooltip: {},
        xAxis: {
          data: time,
        },
        legend: {
          data: ['AC数', '提交量'],
        },
        yAxis: {},
        series: [
          {
            name: 'AC数',
            type: 'line',
            data: pass,
          },
          {
            name: '提交量',
            type: 'line',
            data: submit,
          },
        ],
      })
    },

    // 行拖拽
    rowDrop() {
      // 要侦听拖拽响应的DOM对象
      const tbody = document.querySelector(
        '.TableSolt .el-table__body-wrapper tbody'
      )
      const that = this
      console.log(that.tableDataSolt, 4547878)

      Sortable.create(tbody, {
        animation: 1000,
        ghostClass: 'ghostClass', //设置拖拽停靠样式类名
        chosenClass: 'chosenClass', //设置选中样式类名
        handle: '.el-icon-rank',
        // 结束拖拽后的回调函数
        onEnd({ newIndex, oldIndex }) {
          console.log('拖动了行，当前序号：' + newIndex)
          const currentRow = that.tableDataSolt.splice(oldIndex, 1)[0]
          that.tableDataSolt.splice(newIndex, 0, currentRow)
          console.log(that.tableDataSolt, 4578)
        },
      })
    },
    //排序
    getProblemForProblemListSort() {
      tchGetProblemListForTeamSort({
        team_id: this.teamMessage.id,
      }).then((res) => {
        console.log(res, 565632)
        this.tableDataSolt = res.ojTeamProblemListRelationList
      })
    },
    //排序
    changeSoltNum() {
      this.getProblemForProblemListSort()
      console.log(12121)
      this.isShowSoltNum = true
      this.$nextTick(() => {
        this.rowDrop()
      })
    },
    submitSoltNum() {
      console.log(this.tableDataSolt, 7777888)
      this.soltIds = []
      this.tableDataSolt.map((item) => {
        this.soltIds.push(item.id)
      })
      console.log(this.soltIds, 7777888)
      tchUpdateProblemListSortOfTeam({
        teamProblemListRelationArr: JSON.stringify(this.soltIds),
      }).then((res) => {
        console.log(res)
        this.tchGetProblemListForTeam()
        this.$message.success('修改成功')
      })
      this.isShowSoltNum = false
    },

    //查询
    //难度
    getOjProblemDifficultyList() {
      getOjProblemDifficultyList({}).then((res) => {
        this.conditionList = res.ojProblemDifficultyList
      })
    },
    //知识点
    getOjProblemTagGroupList() {
      getOjProblemTagGroupList().then((res) => {
        this.KnowledgeList = res.ojProblemTagGroupList
        console.log(res, 5653232)
      })
    },
    changeKonw(val) {
      this.form.Know1 = []
      val.map((item) => {
        this.form.Know1.push(item[1])
      })
      console.log(this.form.Know1, 452121)
    },
    //来源
    // sourceList
    getOjProblemSourceList() {
      getOjProblemSourceList({}).then((res) => {
        console.log(res)
        this.sourceList = res.ojProblemSourceList
      })
    },

    search3() {
      this.page_no3 = 1
      this.getTeamOjSubmissionList()
    },
    search2() {
      this.page_no5 = 1
      this.tchGetStuListForAddTeamStu()
    },
    search1(e) {
      // 在回车事件中，手动触发input的blur事件，即可解决问题
      e.target.blur()
      this.page_no6 = 1
      this.tchGetOjProblemlistForTeamAddProblemlist()
    },
    search(e) {
      // 在回车事件中，手动触发input的blur事件，即可解决问题
      e.target.blur()
      this.page_no4 = 1
      this.tchGetOjProblemListForTeamAddProblem()
    },

    setItemProgress(data) {
      console.log(data, 121212152656)

      if (data.pass_count > data.problemnum) {
        return 100
      } else {
        return parseInt((data.pass_count / data.problemnum).toFixed(1) * 100)
      }
    },
    setItemText(data) {
      return () => {
        return +data.pass_count + ' / ' + data.problemnum
      }
    },
    setItemProgress1(data) {
      console.log(data, 121212152656)
      if (data.pass_count > data.problemLisNum) {
        return 100
      } else {
        return parseInt((data.pass_count / data.problemLisNum).toFixed(1) * 100)
      }
    },
    setItemText1(data) {
      return () => {
        return +data.pass_count + ' / ' + data.problemLisNum
      }
    },
    getTeamOjSubmissionList() {
      getTeamOjSubmissionList({
        ...this.formInline,
        team_id: this.teamMessage.id,
        page_no: this.page_no3,
        page_size: this.page_size3,
      }).then((res) => {
        console.log(res)
        this.tableData3 = res.submissionList
        this.total3 = res.total
      })
    },
    goProblem(row, index, rowParent) {
      console.log(row, 11231323)
      console.log(index, 11231323)
      this.ProblemLength = index
      sessionStorage.setItem('tidan', row.title)
      sessionStorage.setItem('description', row.description)

      this.$router.push({
        name: 'teamListOfUestionsList',
        query: {
          teamProblemlistRelationId: rowParent.id,
          ProblemLength: this.ProblemLength,
          problemlist_id: row.id,
          practice: 'practice',
          title: row.title,
          problemAcceptNum: row.problemAcceptNum,
          problem_num: row.problem_num,
          educational_institution_id: row.educational_institution_id,
          description: row.description,
          page_no: this.page_no1,
          page_size: this.page_size1,
          team: this.$route.query.team,
          type: 'tuandui1',
        },
      })
    },
    goNext(row) {
      this.$router.push({
        name: 'questionBankDetails',
        query: {
          id: row.id,
          type1: 'tuandui',
          activeName: this.activeName,
          page_no: this.page_no,
          page_size: this.page_size,
          team: JSON.stringify(this.teamMessage),
        },
      })
    },
    handleClick(val) {
      console.log(val, 111)
      if (val.name === 'second') {
        this.isShowProblem = false
        // this.tchGetProblemForTeam()
        this.page_noSolt = 1
        console.log(this.tableDataSoltUser, 5653237656)
        this.tableDataSoltUser = []
        this.tableDataSoltUser1 = []
        this.tchGetTeamStuRank()
        this.tchGetTeamTotalData()
        this.$nextTick(() => {
          // this.drawLine1()
          this.ojTchGetTeamSubmissiontTotal()
        })
      }
      if (val.name === 'fourth') {
        this.isShowProblem = false
        this.page_noStu = 1
        this.stuListUser1 = []
        this.stuListUser = []
        this.tchGetTeamStuList()
        // this.stuListUser1 = []
        // this.stuListUser = []
        // this.page_noStu = 1
        // this.tchGetProblemListForSearchStuSubmitIn()
      }
      if (val.name === 'third') {
        this.isShowProblem = false

        this.tchGetProblemListForTeam()
      }
      if (val.name === 'fifth') {
        this.getTeamOjSubmissionList()
      }
    },
    //题单
    dels2() {
      if (this.multipleSelection5.length === 0) {
        this.$message.warning('请选中再进行删除!')
        return false
      }
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          tchDeleteProblemListForTeam({
            team_id: this.teamMessage.id,
            problemlistIds: JSON.stringify(this.multipleSelection5),
          }).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功!',
            })
            this.tchGetProblemListForTeam()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    del2(row) {
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          tchDeleteProblemListForTeam({
            team_id: this.teamMessage.id,
            problemlistIds: JSON.stringify([row.id]),
          }).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功!',
            })
            this.tchGetProblemListForTeam()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    tchGetProblemListForTeam() {
      // let num = 1
      tchGetProblemListForTeam({
        team_id: this.teamMessage.id,
        page_no: this.page_no1,
        page_size: this.page_size1,
      }).then((res) => {
        this.tableData1 = res.ojTeamProblemListRelationList
        this.$refs.singleTable.setCurrentRow(
          this.tableData1[this.ProblemLength]
        )
        this.total1 = res.total
        this.stuNum = res.stuNum
        this.tidanTitle = this.tableData1[
          this.ProblemLength
        ].problemListInfo.title
        console.log(res, 45212)
        // userTdList
        this.userTdList = this.tableData1[this.ProblemLength].submissionInfo
        this.tableData1.map((item) => {
          let num = 1
          if (item.submissionInfo.length === 0) {
            item.userNum = num - 1
          } else {
            item.submissionInfo.map((item1) => {
              item1.problemnum = item.problemListInfo.problem_num
              if (item1.pass_count === item1.problemnum) {
                item.userNum = num++
              } else {
                item.userNum = num - 1
              }
            })
          }
        })
        // this.userTdList.map((item3) => {
        //   item3.problemnum = this.tableData1[0].problemListInfo.problem_num
        // })
        console.log(this.tableData1, 5652323)
      })
    },
    //题单高亮
    rowChange(row) {
      console.log(row, 432323)
      this.tidanTitle = row.problemListInfo.title
      // userTdList
      this.userTdList = []
      this.userTdList = row.submissionInfo
      this.userTdList.map((item3) => {
        item3.problemnum = row.problemListInfo.problem_num
      })
    },
    tchGetOjProblemlistForTeamAddProblemlist() {
      tchGetOjProblemlistForTeamAddProblemlist({
        ...this.formTitle,
        team_id: this.teamMessage.id,
        page_no: this.page_no6,
        page_size: this.page_size6,
      }).then((res) => {
        this.tableData6 = res.ojProblemlistList
        this.total6 = res.total
        console.log(res)
      })
    },
    addProblemList() {
      this.dialogVisible3 = true
      this.tchGetOjProblemlistForTeamAddProblemlist()
    },
    handleCurrent6(val) {
      this.page_no6 = val
      this.tchGetOjProblemlistForTeamAddProblemlist()
    },
    submit3() {
      console.log(this.total1 + this.multipleSelection4.length, 56523)
      if (this.total1 + this.multipleSelection4.length > 200) {
        this.$message.warning('添加题单不能超过200个')
      } else {
        tchAddProblemlistForTeam({
          team_id: this.teamMessage.id,
          problemlistIds: JSON.stringify(this.multipleSelection4),
        }).then(() => {
          this.dialogVisible3 = false
          this.$message.success('添加成功')
          this.activeName = 'third'
          this.tchGetProblemListForTeam()
        })
      }
    },
    handleSelectionChange5(val) {
      console.log(val)
      let arr = []
      this.multipleSelection5 = []
      for (let k = 0; k < val.length; k++) {
        arr.push(val[k].problemListInfo.id)
        console.log(arr)
        this.multipleSelection5 = arr
      }
      console.log(this.multipleSelection5)
    },
    handleSelectionChange4(val) {
      console.log(val)
      let arr = []
      this.multipleSelection4 = []
      for (let k = 0; k < val.length; k++) {
        arr.push(val[k].id)
        console.log(arr)
        this.multipleSelection4 = arr
      }
      console.log(this.multipleSelection4)
    },

    //成员
    handleSelectionChange3(val) {
      console.log(val)
      let arr = []
      this.multipleSelection3 = []
      for (let k = 0; k < val.length; k++) {
        arr.push(val[k].student_user_id)
        console.log(arr)
        this.multipleSelection3 = arr
      }
      console.log(this.multipleSelection3)
    },
    dels1() {
      if (this.multipleSelection3.length === 0) {
        this.$message.warning('请选中再进行删除!')
        return false
      }
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          tchDeleteTeamStu({
            team_id: this.teamMessage.id,
            stuIdArr: JSON.stringify(this.multipleSelection3),
          }).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功!',
            })
            this.tchGetTeamStuList()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    del1(row) {
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          tchDeleteTeamStu({
            team_id: this.teamMessage.id,
            stuIdArr: JSON.stringify([row.student_user_id]),
          }).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功!',
            })
            this.tchGetTeamStuList()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    tchGetTeamStuList() {
      this.stuListUser = []

      tchGetTeamStuList({
        team_id: this.teamMessage.id,
        page_no: this.page_no2,
        page_size: this.page_size2,
      }).then((res) => {
        console.log(res)
        this.tableData2 = res.ojTeamStuRelatiohList
        this.total2 = res.total
        this.stuListUserId = this.tableData2[0].student_user_id
        this.problemListInfoList.stuId = this.tableData2[0].student_user_id

        this.$refs.singleTable1.setCurrentRow(this.tableData2[0])
        this.$nextTick(() => {
          this.tchGetProblemListForSearchStuSubmitIn()
        })

        this.stu_name = this.tableData2[0].realname

        // this.tchGetProblemListForSearchStuSubmitIn()
      })
    },
    rowstuList(row) {
      this.isShowProblem = false

      console.log(row, 46562)
      this.problemListInfoList.stuId = row.student_user_id
      this.stu_name = row.realname

      this.stuListUserId = row.student_user_id
      this.stuListUser1 = []
      this.stuListUser = []
      this.page_noStu = 1
      this.tchGetProblemListForSearchStuSubmitIn()
    },
    //学生题单
    tchGetProblemListForSearchStuSubmitIn() {
      this.stuListUser1 = []
      // this.stuListUser = []
      tchGetProblemListForSearchStuSubmitIn({
        stuId: this.stuListUserId,
        team_id: this.teamMessage.id,
        page_no: this.page_noStu,
        page_size: this.page_sizeStu,
      }).then((res) => {
        this.stuListUser1 = res.ojTeamProblemListRelationList
        this.stuListUser.push(...this.stuListUser1)
        console.log(this.stuListUser, 4545123)

        this.stuListUser.map((item) => {
          item.submissionInfo.map((item1) => {
            item1.problemLisNum = item.problemListInfo.problem_num
          })
        })
      })
    },
    loadTableMessage() {
      if (this.stuListUser1.length < this.page_sizeStu) {
        console.log(111)
      } else {
        if (this.stuListUserId != '') {
          this.page_noStu += 1
          console.log(this.page_noStu, 8596326)
          this.tchGetProblemListForSearchStuSubmitIn()
          this.isMore1 = true
        }
      }
    },
    addstu() {
      this.dialogVisible2 = true
      this.tchGetStuListForAddTeamStu()
    },
    tchGetStuListForAddTeamStu() {
      tchGetStuListForAddTeamStu({
        team_id: this.teamMessage.id,
        page_no: this.page_no5,
        page_size: this.page_size5,
        ...this.formStu,
      }).then((res) => {
        console.log(res)
        this.total5 = res.total
        this.tableData5 = res.studentList

        //班级列表转字符串

        for (let k = 0; k < this.tableData5.length; k++) {
          this.tableData5[k].classlist = []
          for (let j = 0; j < this.tableData5[k].stuClassArr.length; j++) {
            // console.log(this.tableData2[k].stuClassArr[j].classInfo.name);
            this.tableData5[k].classlist.push(
              this.tableData5[k].stuClassArr[j].className
            )
          }

          //  console.log(this.tableData2[k].classlist);
          this.tableData5[k].class_str = this.tableData5[k].classlist.join(
            ' , '
          )
        }
      })
    },
    submit2() {
      if (this.total2 + this.multipleSelection2.length > 400) {
        this.$message.warning('团队最大人数不能超过400人')
      } else {
        tchAddTeamStu({
          team_id: this.teamMessage.id,
          stuIdArr: JSON.stringify(this.multipleSelection2),
        }).then(() => {
          this.dialogVisible2 = false
          this.$message.success('添加成功')
          this.activeName = 'fourth'
          this.tchGetTeamStuList()
        })
      }
    },
    handleSelectionChange2(val) {
      console.log(val)
      let arr = []
      this.multipleSelection2 = []
      for (let k = 0; k < val.length; k++) {
        arr.push(val[k].id)
        console.log(arr)
        this.multipleSelection2 = arr
      }
      console.log(this.multipleSelection2)
    },
    handleCurrent5(val) {
      this.page_no5 = val
      this.tchGetStuListForAddTeamStu()
    },
    //题目
    handleSelectionChange1(val) {
      console.log(val)
      let arr = []
      this.multipleSelection1 = []
      for (let k = 0; k < val.length; k++) {
        arr.push(val[k].id)
        console.log(arr)
        this.multipleSelection1 = arr
      }
      console.log(this.multipleSelection1)
    },
    // dels() {
    //   if (this.multipleSelection1.length === 0) {
    //     this.$message.warning('请选中再进行删除!')
    //     return false
    //   }
    //   this.$confirm('是否确认删除？', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     tchDeleteProblemForTeam({
    //       team_id: this.teamMessage.id,
    //       problemIds: JSON.stringify(this.multipleSelection1)
    //     }).then(() => {
    //       this.$message({
    //         type: 'success',
    //         message: '删除成功!'
    //       });
    //       this.tchGetProblemForTeam()

    //     })
    //   }).catch(() => {
    //     this.$message({
    //       type: 'info',
    //       message: '已取消删除'
    //     });
    //   });

    // },
    del(row) {
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          tchDeleteProblemForTeam({
            team_id: this.teamMessage.id,
            problemIds: JSON.stringify([row.id]),
          }).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功!',
            })
            this.tchGetProblemForTeam()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    // tchGetProblemForTeam() {
    //   tchGetProblemForTeam({
    //     team_id: this.teamMessage.id,
    //     page_no: this.page_no,
    //     page_size: this.page_size,

    //   }).then((res) => {
    //     console.log(res)
    //     this.tableData = res.ojProblemList
    //     this.total = res.total
    //   })

    // },
    handleSelectionChange(val) {
      console.log(val)
      let arr = []
      this.multipleSelection = []
      for (let k = 0; k < val.length; k++) {
        arr.push(val[k].id)
        console.log(arr)
        this.multipleSelection = arr
      }
      console.log(this.multipleSelection)
    },
    submit1() {
      tchAddProblemForTeam({
        team_id: this.teamMessage.id,
        problemIds: JSON.stringify(this.multipleSelection),
      }).then((res) => {
        console.log(res)
        this.dialogVisible1 = false
        this.$message.success('添加成功')
        this.activeName = 'second'
        this.tchGetProblemForTeam()
      })
    },

    tchGetOjProblemListForTeamAddProblem() {
      tchGetOjProblemListForTeamAddProblem({
        conditions: JSON.stringify(this.form.conditions),
        Know: JSON.stringify(this.form.Know1),
        source: JSON.stringify(this.form.source),
        team_id: this.teamMessage.id,
        title_code: this.title_code,
        page_no: this.page_no4,
        page_size: this.page_size4,
      }).then((res) => {
        console.log(res)
        this.tableData4 = res.ojProblemList
        this.total4 = res.total
      })
    },
    // addProblem() {
    //   this.dialogVisible1 = true
    //   this.tchGetOjProblemListForTeamAddProblem()
    // },

    addTema() {
      this.dialogVisible = true
    },
    close() {
      // this.$refs["teamMessage"].resetFields();
      this.dialogVisible = false
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          tchAddOrUpdateOjTeam({
            id: this.teamMessage.id,
            title: this.teamMessage.title,
            notic: this.noticTxt,
          }).then(() => {
            sessionStorage.setItem('notic', this.noticTxt)
            this.$message.success('添加成功!')
            this.close()
          })
        }
      })
    },
    goSubDetails() {
      this.$router.push({
        name: 'teamSubDetails',
      })
    },
    goback1() {
      this.$router.push({
        name: 'team',
      })
    },
    handleCurrent(val) {
      this.page_no = val
      this.tchGetProblemForTeam()
    },
    handleCurrent1(val) {
      this.ProblemLength = 0
      this.page_no1 = val
      this.tchGetProblemListForTeam()
    },
    handleCurrent2(val) {
      this.page_no2 = val
      this.tchGetTeamStuList()
    },
    handleCurrent3(val) {
      this.page_no3 = val
      this.getTeamOjSubmissionList()
    },
    handleCurrent4(val) {
      this.page_no4 = val
      this.tchGetOjProblemListForTeamAddProblem()
    },
  },
}
</script>

<style lang="scss" scoped>
.teamDetails {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;

  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.45);
  }
}

.main {
  min-height: calc(100vh - 150px);
  margin: 10px;
  border-radius: 5px;
  box-sizing: border-box;
  background: #fff;
  padding: 20px;
}

.fl {
  float: left;
}

.fr {
  float: right;
  font-size: 16px;
}

.clearfix:after {
  content: "";
  display: block;
  visibility: hidden;
  clear: both;
}

.left {
  padding: 20px;
}

.right_top {
  padding: 20px;
}

.right_top li {
  margin-bottom: 10px;
}

.txt {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}

.image {
  width: 50px;
  height: 50px;
  background: #f00;
  border-radius: 50%;
  overflow: hidden;
}

.SubmitList {
  border: 1px solid #f7f7f7;

  border-radius: 5px;
  padding: 20px;
}

.title1 {
  width: 20%;
  //   border: 1px solid #ccc;
  margin-left: 10px;
  margin-right: 20px;
}

.txt1 {
  width: 100%;
  overflow: hidden; //超出的文本隐藏

  text-overflow: ellipsis; //溢出用省略号显示

  display: -webkit-box;

  -webkit-line-clamp: 1; // 超出多少行

  -webkit-box-orient: vertical;
  font-size: 16px;
  font-weight: bold;
  color: #999;
}

.txt2 {
  font-size: 14px;
  margin-top: 10px;
}

.txt3 {
  color: #5aabe2;
  font-size: 16px;
  font-weight: bold;
  margin-left: 20px;
}

.dataTop li {
  width: 25%;
}

.dataPic {
  width: 40px;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 5px;
  overflow: hidden;
  background-image: url("https://example.com/image.jpg");
  background-position: center center;
}

.dataTxt {
  margin-left: 10px;
}

.dierBox2 {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #c3d3df;
  overflow: hidden;
}

.dierBox1 {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #fdd98d;
  overflow: hidden;
}

.dierBox3 {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #eaa989;
  overflow: hidden;
}

/deep/ .el-date-editor .el-range-separator {
  padding: 0 16px;
}

/deep/.el-dialog {
  border-radius: 10px !important;
}

/deep/ .tox-tinymce {
  min-height: calc(100vh - 208px);
}

/deep/.el-dialog {
  border-radius: 10px !important;
}

/deep/ .CodeMirror-scroll {
  height: calc(93vh) !important;
}

.tableTxtHover:hover {
  color: #5aabe2;
  cursor: pointer;
}
</style>
